module.exports = __webpack_public_path__ + "img/logo_kcc_gray.4a7214e.png";